import { createSlice } from "@reduxjs/toolkit";

export interface TankEta {
    tankNumber: number,
    tankVolume: number,
    shutDownVolume: number,
    productClass2: string,
    isManifolded: boolean,
    inventoryDate: Date,
    volume: number,
    height: number,
    waterHeight: number,
    waterVolume: number
}

export interface OrderEta {
    orderNumber: number,
    orderStatus: string,
    etaStartDate: Date,
    etaEndDate: Date,
    productClass2: string,
    liftGrossQuantity: number,
    carrierName: string
}

export interface EtaState {
    data: {
        SiteId: number,
        SiteCode: string,
        Address: string,
        Phone: string,
        Email: string,
        Active: string,
        Region_Id: string,
        Carrier_Id: string
    },
    tanks: TankEta[],
    orders: OrderEta[]
}

const initialState: EtaState = {
    data: {
        SiteId: 0,
        SiteCode: '',
        Address: '',
        Phone: '',
        Email: '',
        Active: '',
        Region_Id: '',
        Carrier_Id: ''
    },
    tanks: [],
    orders: []
}

const FormatPhoneNumber = (s: string) => {
    if (s !== null && s !== '') {
        if (s.length === 10)
            return s.substr(0, 3) + "-" + s.substr(3, 3) + "-" + s.substr(6, 4);
        if (s.length == 14 && s.indexOf(")") < 0)
            return s.substr(0, 3) + "-" + s.substr(3, 3) + "-" + s.substr(6, 4) + " " + s.substr(10, 4);
    }
    return s;
};

const EtaSlice = createSlice({
    name: 'Eta',
    initialState,
    reducers: {
        setStoreInfo(state: EtaState, action: any) {
            action.payload.data.map((obj: any) => {
                state.data.SiteId = obj.site_Id
                state.data.SiteCode = obj.siteCode;
                state.data.Active = obj.active ? 'Y' : 'N';
                state.data.Address = `${obj.address} ${obj.city} ${obj.state}`;
                state.data.Phone = FormatPhoneNumber(obj.phone);
                state.data.Email = obj.email;
                state.data.Region_Id = obj.region_Id;
                state.data.Carrier_Id = obj.carrier_Id;
            });
            state.tanks.splice(0, state.tanks.length);
            action.payload.tanks.map((tnk: TankEta) => {
                state.tanks.push(tnk);
            });
            state.orders.splice(0, state.orders.length);
            action.payload.orders.map((ord: OrderEta) => {
                state.orders.push(ord);
            })
        }
    }
});

export const EtaActions = EtaSlice.actions;

export default EtaSlice;